import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

declare global {
  interface Window { clarity?: any; }
}

@Injectable({ providedIn: 'root' })
export class ClarityService {
  private loadingPromise: Promise<void> | null = null;

  load(projectId?: string): Promise<void> {
    const pid = projectId || (environment as any).CLARITY_PROJECT_ID;
    if ((window as any).clarity && (window as any).clarity.ready) {
      return Promise.resolve();
    }

    if (this.loadingPromise) {
      return this.loadingPromise;
    }

    this.loadingPromise = new Promise<void>((resolve, reject) => {
      const w: any = window as any;
      // Ensure queue stub exists
      if (typeof w.clarity !== 'function') {
        w.clarity = function () { (w.clarity.q = w.clarity.q || []).push(arguments); };
      }

      // Avoid injecting script twice
  const existing = document.querySelector('script[src^="https://www.clarity.ms/tag/"]') as HTMLScriptElement;
      const script = existing || document.createElement('script');
  script.src = `https://www.clarity.ms/tag/${pid}`;
      script.async = true;

      script.onload = () => {
        const checkReady = setInterval(() => {
          if (typeof (window as any).clarity === 'function') {
            clearInterval(checkReady);
            resolve();
          }
        }, 200);
      };

      script.onerror = (err) => reject(err);

      if (!existing) {
        document.head.appendChild(script);
      } else {
        // If it was already present, assume it's loading; still resolve when ready
        const waitExisting = setInterval(() => {
          if ((window as any).clarity && (window as any).clarity.ready) { clearInterval(waitExisting); resolve(); }
        }, 200);
        setTimeout(() => { clearInterval(waitExisting); resolve(); }, 3000);
      }
    });

    return this.loadingPromise;
  }

  /** Convenience: safely call consent if clarity exists (won't throw). */
  tryConsent(status: 'granted' | 'denied'): void {
    try {
      if (typeof (window as any).clarity === 'function') {
        (window as any).clarity('consent', status);
      }
    } catch { }
  }

  /** Whether clarity object is present and marked ready. */
  isReady(): boolean {
    return !!((window as any).clarity && (window as any).clarity.ready);
  }
}
